/**
 * Cheap, renderer-only vitals. Deliberately free of any Electron IPC so they can
 * be read on every map failure event — including in a plain browser tab and for
 * departments that do not have diagnostic-context collection enabled.
 */

type PerformanceMemory = {
    usedJSHeapSize: number;
    totalJSHeapSize: number;
    jsHeapSizeLimit: number;
};

const bytesToMb = (bytes: number) => Math.round((bytes / (1024 * 1024)) * 100) / 100;

export type JsHeapMb = {
    jsHeapUsedMb: number;
    jsHeapTotalMb: number;
    jsHeapLimitMb: number;
};

/** Chrome-only (`performance.memory`); null elsewhere. */
export function getJsHeapMb(): JsHeapMb | null {
    const memory = (performance as { memory?: PerformanceMemory }).memory;
    if (!memory) {
        return null;
    }
    return {
        jsHeapUsedMb: bytesToMb(memory.usedJSHeapSize),
        jsHeapTotalMb: bytesToMb(memory.totalJSHeapSize),
        jsHeapLimitMb: bytesToMb(memory.jsHeapSizeLimit),
    };
}

export function getDeviceMemoryGb(): number | undefined {
    return (navigator as { deviceMemory?: number }).deviceMemory;
}
